import { render } from "./GiftCardDetail.vue?vue&type=template&id=6ecd4144"
import script from "./GiftCardDetail.vue?vue&type=script&lang=js"
export * from "./GiftCardDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicContainer from "@/components/BasicContainer.vue";
import MainCol from "@/components/MainCol.vue";
import PageFooter from "@/components/PageFooter.vue";
import PageGrid from "@/components/PageGrid.vue";
import PageHeader from "@/components/PageHeader.vue";
import SideCol from "@/components/SideCol.vue";
script.components = Object.assign({}, { BasicContainer, MainCol, PageFooter, PageGrid, PageHeader, SideCol }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicContainer, MainCol, PageFooter, PageGrid, PageHeader, SideCol }, script.__o.components);}